import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dfe66c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tools"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref } from "vue";
import {
  DropdownMenu as VanDropdownMenu,
  DropdownItem as VanDropdownItem,
} from "vant";
import { storeToRefs } from "pinia";
import { invokeAppByYYB } from "@/utils/mob";
import { storageKeys } from "@/constant/storage";
import { useUsersStore } from "@/store/user";
import { isDev } from "@/utils/env-related";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // onClickBanner: {
  //   type: Function,
  //   default: () => null,
  // },
},
  emits: ["onInvokeApp"],
  setup(__props, { emit: emits }) {

const props = __props

const userStore = useUsersStore();

const { userInfo, name, age, expireTime } = storeToRefs(userStore);

const currentEnv = ref(localStorage.getItem("LOCAL_TEST_ENV") || "test-z");

const envList = [
  {
    text: "test-z",
    value: "test-z",
  },
  {
    text: "test-a",
    value: "test-a",
  },
  {
    text: "test-b",
    value: "test-b",
  },
  {
    text: "test-c",
    value: "test-c",
  },
  {
    text: "test-d",
    value: "test-d",
  },
  {
    text: "test-e",
    value: "test-e",
  },
  {
    text: "test-f",
    value: "test-f",
  },
  {
    text: "test-j",
    value: "test-j",
  },
  {
    text: "test-g",
    value: "test-g",
  },
  {
    text: "test-l",
    value: "test-l",
  },
];

// const userInfo = ref(JSON.parse(localStorage.getItem(storageKeys.USER_INFO)));
// const expireTime = ref(localStorage.getItem(storageKeys.TOKEN_EXPIRE_AT));





const handleChangeState = () => {
  // userStore.$patch({
  //   name: "张三",
  //   age: 100,
  //   sex: "女",
  // });\
  userStore.$patch((state) => {
    state.name = "123";
    state.age = 66;
  });
};

const handleResetStore = () => {
  localStorage.removeItem(storageKeys.USER_INFO);
  userStore.$reset();
};

const handleChangeEnv = (val: string) => {
  // console.log('val===', val);
  localStorage.setItem("LOCAL_TEST_ENV", val);
  window.location.reload();
};

const handleLogin = () => {
  // `https://m.qiandaoapp.com/assist/#/login?redirectUrl=https%3A%2F%2Fm.qiandaoapp.com%2Fbill2022%3Fpkg%3D1000%26userid%3D318269489097692433%26ut%3Dtrue`

  // const currentUrl = encodeURIComponent(window.location.href)
  // window.location.href = `https://dev-m.qiandaoapp.com/assist/#/login?redirectUrl=${currentUrl}`
  window.location.href = `${location.origin}/login`;
};

return (_ctx: any,_cache: any) => {
  return (_unref(isDev))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "login",
          onClick: handleLogin
        }, [
          (!_unref(userInfo))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, "登录"))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, _toDisplayString(_unref(userInfo).phone ? "已登录" : "未登录"), 1),
                _createElementVNode("div", null, "user: " + _toDisplayString(_unref(userInfo).displayName), 1),
                _createElementVNode("div", null, "phone: " + _toDisplayString(_unref(userInfo).phone), 1),
                _createElementVNode("div", null, "expireIn: " + _toDisplayString(_unref(expireTime)), 1)
              ]))
        ]),
        _createVNode(_unref(VanDropdownMenu), null, {
          default: _withCtx(() => [
            _createVNode(_unref(VanDropdownItem), {
              modelValue: currentEnv.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentEnv).value = $event)),
              options: envList,
              onChange: handleChangeEnv
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _hoisted_4,
        _createElementVNode("button", {
          style: _normalizeStyle({ fontSize: '3.2rem' }),
          onClick: handleResetStore
        }, " reset store ", 4)
      ]))
    : _createCommentVNode("", true)
}
}

})